import { poll } from './poll.js';

export const RENTAL_COLLECTION_POLL_MAX_ATTEMPTS = 60;

const DEFAULT_RETRY_AFTER_MS = 2000;
const MIN_RETRY_AFTER_MS = 250;
const MAX_RETRY_AFTER_MS = 2000;
const SLOW_PENDING_ATTEMPT = 6;

export function isRentalCollectionAvailabilityPending(payload) {
    return payload?.availability?.state === 'pending';
}

export function rentalCollectionRetryAfterMs(payload) {
    const retryAfterMs = Number(payload?.availability?.retryAfterMs);
    if (!Number.isFinite(retryAfterMs)) return DEFAULT_RETRY_AFTER_MS;

    return Math.max(
        MIN_RETRY_AFTER_MS,
        Math.min(MAX_RETRY_AFTER_MS, Math.round(retryAfterMs))
    );
}

/**
 * Adapts the Rental Collection pending contract to the generic polling loop.
 * The caller still owns request construction, UI state, and cancellation. Its
 * pending callback receives either the checking or slow phase.
 */
export async function pollRentalCollectionAvailability({
    request,
    signal,
    onPending = () => {},
    maxAttempts = RENTAL_COLLECTION_POLL_MAX_ATTEMPTS,
    wait
}) {
    const outcome = await poll({
        request,
        shouldRetry: isRentalCollectionAvailabilityPending,
        retryDelayMs: rentalCollectionRetryAfterMs,
        signal,
        onRetry: (payload, attempt) => {
            // Keep the timing threshold here so UI callers only handle a
            // semantic phase and do not duplicate polling policy.
            const phase = attempt >= SLOW_PENDING_ATTEMPT ? 'slow' : 'checking';
            onPending(payload, attempt, phase);
        },
        maxAttempts,
        ...(wait ? { wait } : {})
    });

    return {
        state: outcome.state === 'complete' ? 'ready' : 'exhausted',
        payload: outcome.value,
        attempts: outcome.attempts
    };
}
